import * as z from "zod/v4";

export const listIntelligentInventoryThreads = {
  name: "listIntelligentInventoryThreads" as const,
  input: z.object({ limit: z.number().optional() }),
  output: z.object({
    threads: z.array(
      z.object({
        threadId: z.string(),
        title: z.string(),
        createdAt: z.string(),
      }),
    ),
  }),
};
